<template>
  <a-form-model
    ref="form"
    :model="form"
    :label-col="{
      span: 0
    }"
    :rules="rules"
    :wrapperCol="{ span: 24 }"
  >
    <a-space class="select-space" :size="10">
      <a-form-model-item
        class="inputContainer"
        prop="key"
        style="margin-bottom: 0"
      >
        <simple-select
          v-model="form.key"
          :options="itemList.map(item => {
            return {
              label: item.name,
              key: item.key
            }
          })"
          :label-in-value="false"
          :disabled="!isCreate"
          :auto-select="false"
          style="width: 180px"
        ></simple-select>
      </a-form-model-item>

      <a-form-model-item
        class="inputContainer"
        prop="method"
        style="margin-bottom: 0"
      >
        <simple-select
          v-model="form.method"
          :options="methods"
          :label-in-value="false"
          :disabled="disabled"
          :auto-select="false"
          style="width: 120px"
        ></simple-select>
      </a-form-model-item>

      <a-form-model-item
        class="inputContainer"
        prop="value_range"
        style="margin-bottom: 0"
      >
        <a-slider
          v-model="form.value_range"
          range
          :tooltip-visible="false"
          :marks="sliderMarks"
          :disabled="disabled"
        ></a-slider>
      </a-form-model-item>

      <a-form-model-item
        style="margin: 0 0 2px 0px"
      >
        <a-space
          v-if="isEdit || isCreate"
          :size="0"
          :class="{
            'btn-space' : true,
            'active-btn': true
          }"
        >
          <a-tooltip title="确认" placement="bottom">
            <a-button type="link" shape="circle" @click="handleOk">
              <a-icon type="check-circle" style="color: #0a9a06; font-size: 18px"/>
            </a-button>
          </a-tooltip>
          <a-popconfirm
            title="确认要删除吗？"
            ok-text="确认"
            cancel-text="取消"
            @confirm="handleDelete"
          >
            <a-tooltip title="删除" placement="bottom">
              <a-button type="link" shape="circle" @click="{}">
                <a-icon type="minus-circle" style="color: #f5222d; font-size: 18px"/>
              </a-button>
            </a-tooltip>
          </a-popconfirm>
          <a-tooltip v-if="!isCreate" title="取消" placement="bottom">
            <a-button type="link" shape="circle" @click="handleCancel">
              <a-icon type="close-circle" style="color: #bfbfbf; font-size: 18px"/>
            </a-button>
          </a-tooltip>
        </a-space>
        <a-space class="btn-space" v-else-if="!isCreate" :size="0">
          <a-tooltip title="编辑" placement="bottom">
            <a-button type="link" shape="circle" @click="isEdit = true">
              <a-icon type="edit" style="color: orange; font-size: 18px"/>
            </a-button>
          </a-tooltip>
        </a-space>
      </a-form-model-item>
    </a-space>
  </a-form-model>
</template>

<script>
import {
  createSourceBusynessIndicator,
  deleteSourceBusynessIndicator,
  updateSourceBusynessIndicator,
  getSourceBusynessIndicator
} from '@/api/source-busyness.js'
import SimpleSelect from '@/components/select/SimpleSelect.vue'

export default {
  name: 'FormItem',
  components: {
    SimpleSelect
  },
  props: {
    itemData: {
      type: Object
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    itemList: {
      type: Array
    }
  },
  data () {
    const methods = ['maximum', 'minimum', 'average', 'current'].map(value => {
      return {
        label: this.$t(`calculation_method.${value}`),
        value
      }
    })
    return {
      methods,
      isEdit: false,
      form: this.itemData,
      rules: {
        key: [
          {
            message: '请选择指标',
            required: true,
            trigger: 'change'
          }
        ],
        method: [
          {
            message: '请选择判断值',
            required: true,
            trigger: 'change'
          }
        ],
        value_range: [
          {
            message: '请设置阈值范围',
            required: true,
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    disabled () {
      if (this.isCreate) return false
      else return !this.isEdit
    },
    sliderMarks () {
      if (this.form.value_range) {
        const obj = {}
        obj[this.form.value_range[0]] = this.form.value_range[0] + '%'
        obj[this.form.value_range[1]] = this.form.value_range[1] + '%'
        return obj
      }
      return {
        0: '0%'
      }
    }
  },
  watch: {
    itemData: {
      handler (v) {
        this.form = v
      },
      deep: true
    }
  },
  methods: {
    handleDelete () {
      if (!this.isCreate) {
        deleteSourceBusynessIndicator(this.itemData.id).then(res => {
          this.$message.success(res.message)
          this.isEdit = false
          this.$emit('refresh')
        })
      } else {
        this.$emit('cancelAdd')
      }
    },
    handleOk () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isCreate) {
            createSourceBusynessIndicator(this.form).then(res => {
              this.$message.success(res.message)
              this.$emit('refresh')
              this.$emit('cancelAdd')
            })
          } else {
            const params = {
              method: this.form.method,
              value_range: this.form.value_range
            }
            updateSourceBusynessIndicator(this.itemData.id, params).then(res => {
              this.$message.success(res.message)
              this.isEdit = false
              this.$emit('refresh')
            })
          }
        }
      })
    },
    handleCancel () {
      this.isEdit = false
      getSourceBusynessIndicator(this.itemData.id).then(res => {
        this.form = res.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.select-space {
  width: 100%;
  &:hover {
    .btn-space {
      opacity: 1;
    }
  }
  :deep(.ant-form-item-control) {
    line-height: 32px;
    .ant-form-explain {
      position: absolute;
      font-size: 13px;
    }
  }
  & > .ant-space-item:nth-of-type(3) {
    min-width: 300px;
    max-width: 580px;
    flex: 1;
  }
  & > .ant-space-item:nth-of-type(4) {
    width: 100px;
  }
  .btn-space {
    opacity: 0;
    padding-top: 6px;
    transition: all .3s;
  }
  .active-btn {
    opacity: 1;
  }
}
</style>
